import stl from "./HeroArea.module.css";
import {useLang} from "@/common/Contexts/LanguageContext";
import {useTranslation} from "@i18n";
import {CDN_LINK} from "@globalConfig";

export const HeroArea = () => {
    const lang = useLang();
    const {t} = useTranslation();
    return (
        <div className={stl.heroArea}>
            <div>
                <div className={stl.mainTitleSection}>
                    <h1 className={stl.textWrapper}>
                        {t("سيارة ترند في السعودية", {ns: "web_trend"})}
                    </h1>
                </div>
            </div>
            <img
                className={stl.illustration}
                alt="Syarah trend"
                src={`${CDN_LINK}/assets/images/trend/trend_${lang === "ar" ? "ar" : "en"}.svg`}
                loading="eager"
                width={430}
                height={155}
            />
        </div>
    );
};
